<template lang="pug">
#app(:class="{'scrollDiasbled':sideBarShow}")
  loading(:active.sync="isLoading" :is-full-page="fullPage" :color="color" :loader="loader")
  .container-fluid
    .row.px-0.campaign.campaignBox(:style = "{ 'background-color': campaignbgColor, 'color': campaignFontColor}").desktop(v-if="$route.matched.some(({ path }) => !(path.startsWith('/shop2')))")
      p.mb-0.w-100.campaignDes(v-for="(item,idx) in bulletinArray" v-if="bulletin === idx" v-html="item.content")
      //-  && Date.parse(item.issueEndDate) > timestemp
    //2022/09/05, jamei
    .row.px-0.campaign.campaignBox.bg-shop2.desktop(v-if="$route.matched.some(({ path }) => path.startsWith('/shop2'))")
      p.mb-0.w-100.campaignDes(v-for="(item,idx) in bulletinArray" v-if="bulletin === idx" v-html="item.content")
      //- TODO 20221128
  //- .px-0.d-flex.justify-content-center
  combineNav2(v-if="$route.matched.some(({ path }) => !(path.startsWith('/shop2')))")
  //- navTest(v-if="$route.matched.some(({ path }) => !(path.startsWith('/shop2')))")
    //- combineNav(v-if="$route.matched.some(({ path }) => (path.startsWith('/shop2')))")
  .container-fluid
    .row.px-0.campaign.campaignBox(:style = "{ 'background-color': campaignbgColor, 'color': campaignFontColor}").mobile(v-if="$route.matched.some(({ path }) => !(path.startsWith('/shop2')))")
      p.mb-0.w-100.campaignDes(v-for="(item,idx) in bulletinArray" v-if="bulletin === idx" v-html="item.content")
    //2022/09/05, jamei
    .row.px-0.campaign.campaignBox.bg-shop2.mobile(v-if="$route.matched.some(({ path }) => path.startsWith('/shop2'))")
      p.mb-0.w-100.campaignDes(v-for="(item,idx) in bulletinArray" v-if="bulletin === idx" v-html="item.content")
  router-view
  .container-fluid.border-top.px-0.footer
    footerComponent(:viewportWidth="fullWidth")
    fbBtn
  copyright(:viewportWidth="fullWidth")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import tpxNavbarhead from './components/tpxNavbarhead'
import navCustomize from './components/navCustomize'
import combineNav2 from './components/combineNav2'
import footerComponent from './components/footer'
import copyright from './components/copyright'
// import scrollBtn from './components/scrollBtn.vue'
import fbBtn from './components/fbBtn.vue'
import actBtn2 from './components/actBtn2.vue'
import actBtn from './components/actBtn.vue'
// import navTest from './components/combineNav2_test.vue'

export default {
  name: 'App',
  components: {
    footerComponent,
    tpxNavbarhead,
    navCustomize,
    combineNav2,
    copyright,
    fbBtn,
    actBtn2,
    actBtn
  },
  data () {
    return {
      fullPage: true,
      color: '#5c87a6',
      loader: 'dots',
      fullWidth: document.body.clientWidth,
      bulletin: 0,
      timestemp: null,
      campaignbgColor: null,
      campaignFontColor: null,
      today: new Date(),
      testDate: new Date('Mon Jan 01 2024 12:00:00 GMT+0800 (台北標準時間)'),
      beginDate: new Date('Thu Feb 01 2024 12:00:00 GMT+0800 (台北標準時間)'),
      endDate: new Date('Thu Feb 29 2024 11:59:59 GMT+0800 (台北標準時間)')
    }
  },
  methods: {
    ...mapActions('bulletinModules', ['getBulletin']),
    scrollToTop () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    ...mapState('bulletinModules', ['bulletinArray']),
    ...mapState({
      sideBarShow: (state) => state.sideBarShow,
      openStyleModal: (state) => state.openStyleModal,
      productId: (state) => state.standardModules.productId
    })
  },
  async mounted () {
    const vm = this
    // resize 事件
    window.onresize = () => {
      return (() => {
        vm.fullWidth = document.documentElement.clientWidth
      })()
    }

    let date = new Date()
    let timestemp = date.getTime()
    vm.timestemp = timestemp
    // 跑馬燈邏輯
    await setInterval(function () {
      if (vm.bulletin < vm.bulletinArray.length - 1) {
        vm.bulletin += 1
      } else {
        vm.bulletin = 0
      }
    }, 2500)
  },
  async created () {
    const vm = this
    await this.getBulletin()
    // 跑馬燈背景色&文字顏色 改第一筆值
    vm.campaignFontColor = await vm.bulletinArray[0].forecolor
    vm.campaignbgColor = await vm.bulletinArray[0].bgcolor
  },
  watch: {
    // val 為改變的值
    fullWidth (val) {
      this.fullWidth = val
    }
  }
}
</script>

<style lang="scss">
@import "./assets/all.scss";
$s14: 14px;
$s20: 20px;
$serif: "Noto Serif TC", serif;
body {
  -ms-overflow-style: none;
}

* {
  box-sizing: border-box;
}
// 解決RWD螢幕寬度問題 https://css-tricks.com/forums/topic/best-media-query-excluding-scroll-solution/
@media (min-width: 1080px) and (max-width: 1080px) {
  html {
    overflow: hidden;
    height: 100%;
    font-size: 100%;
  }

  body {
    height: 100%;
    overflow-y: scroll;
    position: relative;
  }
}
#app {
  font-family: Arial, Helvetica, "Microsoft JhengHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
// 側邊欄打開不給滾動
.scrollDiasbled {
  height: 100vh;
  overflow: hidden;
}
// 最上方促銷活動
.campaign {
  font-size: 1.1rem;
  max-width: 100vw;
  background-color: #5c87a6;
}
.campaignBox {
  height: 50px;
  box-sizing: border-box;
  color: white;
}
@media (max-width: 1270px) {
  .campaign {
    font-size: 1rem;
  }
}
.campaignDes {
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    color: white;
  }
}
.footer {
  background-color: #f4f4f1;
  position: relative;
}

// .darkBg{
//   width: 100%;
//   background: rgba(0,0,0,.4);
//   height: 100vh;
//   position: absolute;
//   top:0;
//   bottom:0;
//   right:0;
//   z-index:99;
// }
// .overlay{
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   right: 0px;
//   bottom: 0px;
//   background-color: rgba(0, 0, 0, 0.4);
//   z-index:100;

//   .overlay-content {
//     height: 100%;
//     overflow: scroll;
//   }
// }
.mobile {
  display: none;
}
.desktop {
  display: flex;
}
@media (max-width: 1275px) {
  .mobile {
    display: flex;
  }
  .desktop {
    display: none;
  }
}

//2022/09/05, jamei
.bg-shop2 {
  background-color: #f8c15c;
}
</style>



// WEBPACK FOOTER //
// src/App.vue